import React from 'react';
import PropTypes from 'prop-types';
import { reduxForm, Field } from 'redux-form';
import { required } from 'redux-form-validators';

import { DefaultButton, ReduxTextField, ReduxSelectField } from 'common/components';

import { editWithdrawalMetadata, changePaymentStatus } from 'backoffice/payments/_redux';
import staticStyles from './style';

const EditWithdrawalFieldForm = ({
  fieldKey,
  fieldType,
  options,
  handleSubmit,
  pristine,
  submitting,
  invalid,
  dispatch,
  error,
  id,
}) => {
  const getMetadataTextId = key => {
    const map = {
      status: 'justStatus',
      beneficiary_name: 'justBeneficiaryName',
      iban_number: 'justIBANNumber',
      address: 'justAddress',
      city: 'justCity',
      country: 'justCountry',
    };
    return map[key] || key;
  };

  const submit = handleSubmit(values => {
    if (fieldKey === 'status') {
      return changePaymentStatus({ id, type: 'withdraw', status: values[fieldKey] }, dispatch);
    }
    return editWithdrawalMetadata({ id, key: fieldKey, value: values[fieldKey] }, dispatch);
  });

  return (
    <div className="EditWithdrawalFieldForm__content">
      <form className="EditWithdrawalFieldForm" onSubmit={submit}>
        <div className="EditWithdrawalFieldForm__inputs-inner">
          {fieldType === 'select' || fieldType === 'creatable' ? (
            <Field
              component={ReduxSelectField}
              name={fieldKey}
              textId={getMetadataTextId(fieldKey)}
              options={options}
              isCreatable={fieldType === 'creatable'}
              validate={[required()]}
            />
          ) : (
            <Field
              component={ReduxTextField}
              autoComplete="off"
              type="text"
              name={fieldKey}
              textId={getMetadataTextId(fieldKey)}
              validate={[required()]}
            />
          )}
        </div>

        <DefaultButton
          textId="justChange"
          type="submit"
          loading={submitting}
          disabled={invalid || pristine || submitting}
          filled
        />
        {error && <strong className="formError">{error}</strong>}
      </form>
      <style jsx>{staticStyles}</style>
    </div>
  );
};

EditWithdrawalFieldForm.propTypes = {
  fieldKey: PropTypes.string.isRequired,
  fieldType: PropTypes.oneOf(['text', 'select', 'creatable']).isRequired,
  options: PropTypes.array,
  handleSubmit: PropTypes.func.isRequired,
  pristine: PropTypes.bool.isRequired,
  invalid: PropTypes.bool.isRequired,
  submitting: PropTypes.bool.isRequired,
  dispatch: PropTypes.func.isRequired,
  error: PropTypes.string,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

EditWithdrawalFieldForm.defaultProps = {
  options: [],
  error: '',
};

export default reduxForm({
  form: 'EditWithdrawalFieldForm',
  enableReinitialize: true,
  onSubmitSuccess(result, dispatch, props) {
    if (props.onSubmitSuccess) {
      props.onSubmitSuccess();
    }
  },
})(EditWithdrawalFieldForm);
